import { TFunction } from 'i18next'

import { VoucherStateReasons } from '../types'

export const getVoucherStateReasons = (t: TFunction): Record<VoucherStateReasons, string> => ({
  [VoucherStateReasons.Duplicate]: t('voucher.inbox.state_reasons.reason_duplicate'),
  [VoucherStateReasons.NotRelevant]: t('voucher.inbox.state_reasons.reason_duplicate'),
})
